import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/orderlist/orderdetailsbg@2x.png';
const _withScopeId = n => (_pushScopeId("data-v-46e9ff77"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "details-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "content-bg",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = {
  key: 2,
  class: "remark"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("span", null, "订单备注")], -1));
const _hoisted_6 = {
  class: "remarktext"
};
const _hoisted_7 = {
  class: "order_paper"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单号", -1));
const _hoisted_9 = ["copyData"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copyicon"
}, "复制", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下单时间", -1));
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "付款时间", -1));
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "定金支付时间", -1));
const _hoisted_16 = {
  key: 2
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "尾款支付时间", -1));
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"l\" data-v-46e9ff77></div><div class=\"m\" data-v-46e9ff77><div class=\"t\" data-v-46e9ff77>福利活动享不停～</div><div class=\"b\" data-v-46e9ff77>添加小助理，进入「爱好者交流群」</div></div><div class=\"r\" data-v-46e9ff77>点击添加</div>", 3);
const _hoisted_22 = [_hoisted_19];
const _hoisted_23 = {
  class: "evaluate-gift-wrap"
};
const _hoisted_24 = {
  class: "evaluate-gift-inner"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg-img"
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "gift-notice"
}, "恭喜你，获得评价礼包", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_detailsHeader = _resolveComponent("detailsHeader");
  const _component_detailsAddress = _resolveComponent("detailsAddress");
  const _component_details_product_content = _resolveComponent("details-product-content");
  const _component_detailsStatus = _resolveComponent("detailsStatus");
  const _component_dialog_btn = _resolveComponent("dialog-btn");
  const _component_orderTel = _resolveComponent("orderTel");
  const _component_orderRemark = _resolveComponent("orderRemark");
  const _component_openCardlist = _resolveComponent("openCardlist");
  const _component_orderRefund = _resolveComponent("orderRefund");
  const _component_topay = _resolveComponent("topay");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$setup.orderInfo ? (_openBlock(), _createBlock(_component_detailsHeader, {
    key: 0,
    type: "product",
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderInfo"])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(['details-content', {
      content: $data.env.isSafari() && $data.env.isIos()
    }])
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, $setup.orderInfo ? (_openBlock(), _createBlock(_component_detailsAddress, {
    key: 0,
    type: "product",
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderInfo"])) : _createCommentVNode("", true), $setup.orderInfo ? (_openBlock(), _createBlock(_component_details_product_content, {
    key: 1,
    orderInfo: $setup.orderInfo,
    onOpenboxmore: $options.openboxmore
  }, null, 8, ["orderInfo", "onOpenboxmore"])) : _createCommentVNode("", true), $setup.orderInfo.remark ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString($setup.orderInfo.remark), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, [_hoisted_8, _createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.share && $options.share(...args)),
    ref: "copy",
    class: "copyp",
    copyData: $setup.orderInfo.order_id
  }, [_createTextVNode(_toDisplayString($setup.orderInfo.order_id) + " ", 1), _hoisted_10], 8, _hoisted_9)]), _createElementVNode("p", null, [_hoisted_11, _createElementVNode("span", null, _toDisplayString($setup.orderInfo.ctime), 1)]), $setup.orderInfo.pay_time && $setup.orderInfo.presale_type != 2 ? (_openBlock(), _createElementBlock("p", _hoisted_12, [_hoisted_13, _createElementVNode("span", null, _toDisplayString($setup.orderInfo.pay_time), 1)])) : _createCommentVNode("", true), $setup.orderInfo.first_pay_time ? (_openBlock(), _createElementBlock("p", _hoisted_14, [_hoisted_15, _createElementVNode("span", null, _toDisplayString($setup.orderInfo.first_pay_time), 1)])) : _createCommentVNode("", true), $setup.orderInfo.tail_pay_time ? (_openBlock(), _createElementBlock("p", _hoisted_16, [_hoisted_17, _createElementVNode("span", null, _toDisplayString($setup.orderInfo.tail_pay_time), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "html",
    ref: "html",
    innerHTML: $data.html
  }, null, 8, _hoisted_18), _withDirectives(_createElementVNode("div", {
    class: "add_wx_box",
    onClick: _cache[1] || (_cache[1] = $event => $options.addWxGroup())
  }, _hoisted_22, 512), [[_vShow, $data.env.isWxApp()]])])], 2), $setup.orderInfo && $setup.orderInfo.order_btns && $setup.orderInfo.order_btns.length ? (_openBlock(), _createBlock(_component_detailsStatus, {
    key: 1,
    onShow_dialog: $options.show_dialog,
    butttonList: $setup.orderInfo.order_btns,
    onToOp: _cache[2] || (_cache[2] = e => $options.op(e))
  }, null, 8, ["onShow_dialog", "butttonList"])) : _createCommentVNode("", true), _createVNode(_component_dialog_btn, {
    dialog_show: $data.dialog_show,
    onToParent: $options.close_dialog,
    dialog_btn: $data.dialog_btn,
    list: true,
    onToOp: _cache[3] || (_cache[3] = e => {
      $options.op(e);
      $options.close_dialog();
    })
  }, null, 8, ["dialog_show", "onToParent", "dialog_btn"]), $data.telShow ? (_openBlock(), _createBlock(_component_orderTel, {
    key: 2,
    onOk: _cache[4] || (_cache[4] = $event => $options.close('telShow')),
    onDialogBack: _cache[5] || (_cache[5] = $event => $data.telShow = false),
    orderId: $setup.orderId,
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderId", "orderInfo"])) : _createCommentVNode("", true), $data.remarkShow ? (_openBlock(), _createBlock(_component_orderRemark, {
    key: 3,
    onOk: _cache[6] || (_cache[6] = $event => $options.close('remarkShow')),
    onDialogBack: _cache[7] || (_cache[7] = $event => $data.remarkShow = false),
    orderId: $setup.orderId,
    orderType: $data.orderType,
    remark: $setup.orderInfo.remark,
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderId", "orderType", "remark", "orderInfo"])) : _createCommentVNode("", true), $data.openCardlistMod ? (_openBlock(), _createBlock(_component_openCardlist, {
    key: 4,
    orderInfo: $setup.orderInfo,
    orderId: $setup.orderId,
    onClose: _cache[8] || (_cache[8] = $event => $data.openCardlistMod = false)
  }, null, 8, ["orderInfo", "orderId"])) : _createCommentVNode("", true), _createVNode(_component_orderRefund, {
    orderRefundShow: $data.orderRefundShow,
    onDialogBack: _cache[9] || (_cache[9] = $event => $data.orderRefundShow = false),
    onToOp: _cache[10] || (_cache[10] = e => $options.refundFn(e, _ctx.orderitem)),
    orderType: $data.orderType,
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderRefundShow", "orderType", "orderInfo"]), $data.payShow ? (_openBlock(), _createBlock(_component_topay, {
    key: 5,
    class: "topay",
    orderInfo: $setup.orderInfo,
    pay_resource: $data.pay_resource,
    list: $data.methodsList,
    onClose: _cache[11] || (_cache[11] = $event => $data.payShow = false),
    onPayClick: $options.payClick
  }, null, 8, ["orderInfo", "pay_resource", "list", "onPayClick"])) : _createCommentVNode("", true), _createVNode(_component_dialog_btn, {
    dialog_show: $data.dialog_address,
    onToParent: _cache[12] || (_cache[12] = $event => $data.dialog_address = false),
    dialog_btn: $data.addressBtn,
    order_type: _ctx.order_type,
    list: true,
    onToOp: _cache[13] || (_cache[13] = e => $options.toAddress(e, _ctx.orderitem, $data.orderType))
  }, null, 8, ["dialog_show", "dialog_btn", "order_type"]), _withDirectives(_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _hoisted_26, _createElementVNode("div", {
    class: "gift-confirm",
    onClick: _cache[14] || (_cache[14] = $event => $options.op({
      'type': 'order_comment_add'
    }))
  }, " 立即评论 ")])], 512), [[_vShow, $data.giftWrapShow]])]);
}